import React, { Component } from 'react';
import { Button } from 'carbon-components-react';
import Numeral from 'numeral';
import StepCard from '../../StepCard';
import WarningNotification from '../../WarningNotification';
import CurrencyInput from '../../CurrencyInput';

Numeral.locale('pt-br');

class DinamicAndBudgets extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orcamento: props.campaignItem && props.campaignItem[0].orcamento,
      descricaoDinamica: props.campaignItem && props.campaignItem[0].descricaoDinamica,
      notification: true,
      salvouDinamicaBudget: false,
    };
  }

  componentWillMount = () => {
    const {data} = this.props;
    if(data && data.descricaoDinamica){
      this.setState({salvouDinamicaBudget: true});
    }
  }

  txtWarning = () => (
    <div>
      <p>        
        {'Aprovação do budget precisa ser feita antes pelo '}
        <span className="font-bold">Gerente Comercial</span>
      </p>
    </div>
  );

  closeNotification = () => {
    this.setState({
      notification: false,
    });
  };

  renderDescription() {
    const { step, data } = this.props;

    if (data && data.descricaoDinamica) {
      return (
        <div className="font-size-13" style={{ color: '#36474f' }}>
          <strong>Dinâmica</strong>
          <br />
          {data.descricaoDinamica}
          <br />
          <strong>Orçamento:</strong>
          {' '}
          <br />
          R$
          {' '}
          {Numeral(data.orcamento).format('0.00') }
        </div>
      );
    }

    return step.description;
  }

  onChangeText = (event) => {
    this.setState(
      {
        [event.target.id]: event.target.value,
      }
    );
  };

  canSave = () => {
    const { descricaoDinamica, orcamento } = this.state;
    if (descricaoDinamica && orcamento) {     
      this.setState({ salvouDinamicaBudget: true });
      this.stepCardRef.toggleContent();
    } else {
      return false;
    }
    return undefined;
  };

  cancel = () => {
    // const { selectedValue } = this.props;
    // this.setState({ selectedValue });
    this.stepCardRef.toggleContent();
  };

  save = async () => {
    const { descricaoDinamica, orcamento } = this.state;
    const { saveStep /* , selectedValue */ } = this.props;
    await saveStep({
      descricaoDinamica,
      orcamento,
      salvouDinamicaBudget: true,
    });

    await this.canSave()
    // this.setState({ selectedValue });
  };

  render() {
    const { step, buttonIn, isIstore } = this.props;
    const {
      orcamento, descricaoDinamica, salvouDinamicaBudget, notification,
    } = this.state;

    return (
      <StepCard
        onRef={(ref) => {
          this.stepCardRef = ref;
        }}
        title={step.title}
        description={this.renderDescription()}
        isFinished={salvouDinamicaBudget}
        disabled={isIstore}
      >
        <div className="bx--row mg-top-20">
          <div className="bx--col-xs-12">
            <div className="bx--form-item">
              <textarea
                id="descricaoDinamica"
                className="bx--text-area"
                defaultValue={descricaoDinamica || null}
                onChange={this.onChangeText}
                rows="4"
                cols="50"
                placeholder="ex: Compre acima de R$ 50 e ganhe um brinde."
              />
              <label htmlFor="text-area-2" className="bx--label">
                {' '}
                Dinâmica
                {' '}
              </label>
            </div>
          </div>
          <div className="bx--col-xs-12 bx--col-md-4">
            <div className="bx--form-item mg-top-20 ">
              <CurrencyInput
                id="orcamento"
                className="bx--text-input bx--text__input"
                label="Budget aprovado"
                fixedDecimalScale
                decimalSeparator=","
                thousandSeparator="."
                prefix="R$ "
                placeholder="R$ 0,00"
                value={orcamento}
                allowNegative={false}
                decimalScale={2}
                onValueChange={(values, e) => {
                  this.setState({ [e.target.id]: values.value ? Number(values.value) : null });
                }}
              />
            </div>
          </div>
          {notification && (
            <div className="bx--col-xs-12">
              <WarningNotification
                closeNotification={this.closeNotification}
                header="Atenção"
                content={this.txtWarning()}
              />
            </div>
          )}
        </div>
        {buttonIn && (
          <div className="bx--row">
            <div className="bx--col-md-12">
              <br />
              {' '}
              <br />
              <div className="v-md-margin mg-top-40">
                <Button onClick={this.save}>Avançar</Button>
                <Button kind="ghost" className="h-sm-margin" onClick={this.cancel}>
                  Cancelar
                </Button>
              </div>
            </div>
          </div>
        )}
      </StepCard>
    );
  }
}

export default DinamicAndBudgets;



// WEBPACK FOOTER //
// ./src/components/trades/campaign/DinamicsAndBudgts.js